import { ServerURI } from '../globals';

export async function completeSignup(user, input) {
  const token = await user.getIdToken();
  const response = await fetch(`${ServerURI}/api/signup/complete`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Could not complete signup. Please try again.');
  return data;
}
